import { render, staticRenderFns } from "./TrainingList.vue?vue&type=template&id=587d00e4&scoped=true"
import script from "./TrainingList.vue?vue&type=script&lang=js"
export * from "./TrainingList.vue?vue&type=script&lang=js"
import style0 from "./TrainingList.vue?vue&type=style&index=0&id=587d00e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d00e4",
  null
  
)

export default component.exports